module.exports = __webpack_public_path__ + "img/6.3d070ac5.png";